module.exports = __webpack_public_path__ + "assets/img/addition_icon.76ca435b.svg";